import { useState } from "react";
import { LogoIcon } from "../../Logo";

const PromptSuggestions = ({ onPromptSelect }) => {
  const [activeTab, setActiveTab] = useState("write");

  const categories = [
    {
      id: "write",
      label: "Write",
      activeGradient: "from-blue-500 to-cyan-500",
      activeText: "text-blue-100",
    },
    {
      id: "explore",
      label: "Explore",
      activeGradient: "from-purple-500 to-pink-500",
      activeText: "text-purple-100",
    },
    {
      id: "code",
      label: "Code",
      activeGradient: "from-emerald-500 to-teal-500",
      activeText: "text-emerald-100",
    },
    {
      id: "learn",
      label: "Learn",
      activeGradient: "from-amber-500 to-orange-500",
      activeText: "text-amber-100",
    },
  ];

  const prompts = {
    write: [
      "Write a poem about artificial intelligence and human connection",
      "Help me write a compelling cover letter for a software engineering role",
      "Create a short mystery story set in a futuristic city",
      "Differentiate between AI and ML in a tabular format",
    ],
    explore: [
      "Top emerging technologies to watch in 2025",
      "Compare different cloud service providers",
      "Best places to see the northern lights",
      "Historical events that shaped modern computing",
    ],
    code: [
      "Show me how to implement authentication in a MERN stack app",
      "Explain how to optimize React performance",
      "Python code example for reading and writing JSON files",
      "How to create a responsive navigation bar with CSS Grid",
    ],
    learn: [
      "Explain blockchain technology in simple terms",
      "How does machine learning differ from traditional programming?",
      "Introduction to quantum computing basics",
      "Show that tan(A + B) = (tanA + tanB)/(1 - tanA·tanB)",
    ],
  };

  return (
    <div className="max-w-2xl mx-auto py-8 px-4 text-left flex flex-col justify-center min-h-[60vh]">
      <div className="flex items-start flex-col gap-4 mb-6 pl-1">
        <LogoIcon className="w-8 h-8" fillClassName="fill-fg-40" />
        <h2 className="text-2xl font-semibold">
          <span className="text-fg-60">What can I help</span>{" "}
          <span className="text-fg-40">with?</span>
        </h2>
      </div>

      {/* Tabs */}
      <div className="mb-4">
        <div className="inline-flex gap-1 bg-bg-60 rounded-full p-1">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveTab(category.id)}
              className={`px-4 py-2 text-sm font-medium rounded-full border transition-all duration-200 ${
                activeTab === category.id
                  ? "bg-[#f3eff8] text-[#A758DB] border-[#A758DB] dark:bg-[#2d1b3d] dark:text-[#c084fc] dark:border-[#c084fc]"
                  : "text-fg-60 hover:text-fg-40 bg-bg-70 border-bd-50 hover:border-fg-50"
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>
      </div>

      {/* Prompts List */}
      <div className="space-y-1">
        {prompts[activeTab].map((prompt, index) => (
          <div
            key={index}
            onClick={() => onPromptSelect(prompt)}
            className="p-2.5 rounded-lg hover:bg-bg-50 group cursor-pointer transition-colors duration-200"
          >
            <p className="text-fg-60 group-hover:text-fg-50 text-sm transition-colors duration-200">
              {prompt}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromptSuggestions;
